import { render } from "./QuotationList.vue?vue&type=template&id=59a838b2"
import script from "./QuotationList.vue?vue&type=script&lang=js"
export * from "./QuotationList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__